export default function validatePerfil(values) {
    let errors = {}

    // Email Errors
    if(!values.email){
        errors.email = "Email requerido";
    } else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = "direccion de email invalido";
    }

    // Password Errors
    return errors;

}
